module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display1-fbe7c8cb6c6a3c5a6b32ceaf1e88db85.svg";